import { defineComponent as _defineComponent } from 'vue'
import { computed, getCurrentInstance, onMounted, ref } from 'vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'OpenInBrowser',
  setup(__props, { expose }) {

const { proxy: vm } = getCurrentInstance()!;

const pageData = ref<any>(vm.$t("openInBrowser"));
const close = ref(false);
const browser = ref<any>({});
function maskClick() {
    close.value = true;
}

function showMask(){
    close.value = false;
}

// 是否需要引导
const needGuide = computed(() => {
    return browser.value.isBytedance // tiktok
    || (browser.value.isWechat && browser.value.isAndroid)// 微信（仅安卓）
})

const show = computed(() => {
    return needGuide.value && !close.value
})

onMounted(() => {
    // @ts-ignore
    console.log("browser",vm.$mobile.browser)
    // @ts-ignore
    browser.value = vm.$mobile.browser;
})

expose({
    showMask,
    needGuide,
})

return { __sfc: true,vm, pageData, close, browser, maskClick, showMask, needGuide, show }
}

})